import React from 'react';
import styled from 'styled-components';

const ScoreBoard = ({ score, highScore }) => {
  return (
    <ScoreBoardContainer>
      <ScoreItem>
        <ScoreLabel>현재 점수</ScoreLabel>
        <ScoreValue>{score}</ScoreValue>
      </ScoreItem>
      <ScoreItem>
        <ScoreLabel>최고 점수</ScoreLabel>
        <ScoreValue>{highScore}</ScoreValue>
      </ScoreItem>
    </ScoreBoardContainer>
  );
};

const ScoreBoardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  padding: 10px;
  background-color: #143d28;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`;

const ScoreItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ScoreLabel = styled.span`
  color: #f8cb66;
  font-size: 0.9rem;
  margin-bottom: 5px;
`;

const ScoreValue = styled.span`
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
`;

export default ScoreBoard;
